import { Capsule } from 'Capsule';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import './locales/status_capsule-en.json';
import { MemberDetailsMembershipStatus } from './ProjectGroup.types';

const statusClassNamesMap = {
    [MemberDetailsMembershipStatus.CREATOR]: {
        base: 'bg-primary-100',
        content: 'text-primary',
    },
    [MemberDetailsMembershipStatus.ACCEPTED]: {
        base: 'bg-black',
        content: 'text-white',
    },
    [MemberDetailsMembershipStatus.INVITED]: {
        base: 'bg-yellow-100',
        content: 'text-yellow-700',
    },
    [MemberDetailsMembershipStatus.DECLINED]: {
        base: 'bg-slate-grey-50',
        content: 'text-slate-grey-700',
    },
};

export function StatusCapsule({ status, count }: { status: MemberDetailsMembershipStatus; count?: number }) {
    const { t } = useTranslation('back_royal');
    const localeKey = `status_capsule.${status}`;
    return (
        <Capsule
            size="sm"
            variant="flat"
            classNames={{
                base: statusClassNamesMap[status].base,
                content: twMerge('uppercase font-semibold px-1 pt-2 pb-1.5', statusClassNamesMap[status].content),
            }}
        >
            {count ? `${count} ${t(localeKey)}` : t(localeKey)}
        </Capsule>
    );
}
